module.exports = __webpack_public_path__ + "img/img17.6f6a9cac.jpg";